import React from "react";
import styles from "./style.module.scss";
import { useDomainContext } from "@hooks/useDomainContext";

export default function WinnerBuyerLoader() {
    const { category } = useDomainContext();

    return (
        <div className={styles["loading-container"]}>
            <div className="flex flex-col justify-center items-center h-full max-w-3xl mx-auto text-center ">
                <Loading />
                <h2 className="text-4xl font-semibold mb-10">
                    {category?.config?.winnerBuyerLoadingTitle ||
                        "Finding the Right Provider for You"}
                </h2>
                <p className="text-gray-600 mb-6  max-w-xl">
                    {category?.config?.winnerBuyerLoadingDescription ||
                        "Hang tight, we're matching you with a trusted service provider based on your request. This just takes a few moments."}
                </p>
            </div>
        </div>
    );
}

function Loading() {
    return (
        <div className="relative mb-10">
            <svg
                width="86"
                height="115"
                viewBox="0 0 86 115"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M85.8078 88.5V9.80802C85.8078 7.1866 84.7869 4.72354 82.9355 2.87478C81.0842 1.02085 78.6212 0 76 0H24.6392C23.984 0 23.3556 0.260322 22.8922 0.723691L0.880491 22.7354C0.417346 23.1988 0.156799 23.8272 0.156799 24.4824V105.192C0.156799 110.6 4.55667 115 9.96482 115H76.0002C81.4081 115 85.808 110.6 85.808 105.192V86.8488H80.8666V105.192C80.8666 107.875 78.6834 110.059 76.0002 110.059H9.96482C7.28141 110.059 5.09843 107.875 5.09843 105.192V30.6217H20.9707C26.3788 30.6217 30.7787 26.2218 30.7787 20.8137V4.94141H76.0002C77.3002 4.94141 78.5217 5.44745 79.4417 6.3688C80.3605 7.28633 80.8666 8.50775 80.8666 9.80802V88.5H85.8078ZM25.8371 20.8137C25.8371 23.4971 23.6539 25.6803 20.9704 25.6803H5.09821V25.5057L25.6625 4.94141H25.8371V20.8137Z"
                    fill="black"
                />
                <path
                    d="M39.3137 48.9648H20.9707C19.6062 48.9648 18.5 47.8586 18.5 46.4941C18.5 45.1296 19.6062 44.0234 20.9707 44.0234H39.3139C40.6784 44.0234 41.7846 45.1296 41.7846 46.4941C41.7846 47.8586 40.6782 48.9648 39.3137 48.9648Z"
                    fill="black"
                />
                <path
                    d="M35.6451 63.6393H20.9707C19.6062 63.6393 18.5 62.5331 18.5 61.1685C18.5 59.804 19.6062 58.6978 20.9707 58.6978H35.6451C37.0096 58.6978 38.1158 59.804 38.1158 61.1685C38.1158 62.5331 37.0096 63.6393 35.6451 63.6393Z"
                    fill="black"
                />
                <path
                    d="M35.6451 78.3139H20.9707C19.6062 78.3139 18.5 77.2077 18.5 75.8432C18.5 74.4787 19.6062 73.3725 20.9707 73.3725H35.6451C37.0096 73.3725 38.1158 74.4787 38.1158 75.8432C38.1158 77.2077 37.0096 78.3139 35.6451 78.3139Z"
                    fill="black"
                />
                <path
                    d="M39.3137 92.9883H20.9707C19.6062 92.9883 18.5 91.8821 18.5 90.5176C18.5 89.1531 19.6062 88.0469 20.9707 88.0469H39.3139C40.6784 88.0469 41.7846 89.1531 41.7846 90.5176C41.7846 91.8821 40.6782 92.9883 39.3137 92.9883Z"
                    fill="black"
                />
            </svg>
            <svg
                width="71"
                height="71"
                viewBox="0 0 71 71"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className={styles.magnifyingGlass}
            >
                <path
                    d="M52.0902 48.4391L43.6251 39.9738C47.0735 35.7543 49.1453 30.3677 49.1453 24.5056C49.1453 11.0059 38.1626 0.0232239 24.6629 0.0232239C11.1632 0.0232239 0.180481 11.0059 0.180481 24.5056C0.180481 38.0053 11.1632 48.9881 24.6629 48.9881C30.5248 48.9881 35.9113 46.9163 40.1309 43.4678L48.5959 51.9331C49.0784 52.4156 49.7107 52.6568 50.3429 52.6568C50.975 52.6568 51.6077 52.4156 52.09 51.9331C53.0549 50.9684 53.0549 49.404 52.0902 48.4391ZM5.12166 24.5059C5.12166 13.7309 13.8877 4.96486 24.6627 4.96486C35.4376 4.96486 44.2037 13.7309 44.2037 24.5059C44.2037 35.2808 35.4376 44.0469 24.6627 44.0469C13.8879 44.0469 5.12166 35.2808 5.12166 24.5059Z"
                    fill="#FF8B8B"
                />

                <path
                    d="M63.1832 70.6862C61.1381 70.6862 59.2146 69.8891 57.7676 68.4419L48.5959 59.2704C47.1488 57.8231 46.3519 55.8997 46.3519 53.8547C46.3519 51.8098 47.1488 49.8863 48.5959 48.4391C50.0431 46.9917 51.9667 46.1946 54.0117 46.1946C56.0566 46.1946 57.9801 46.9917 59.4273 48.4389L68.5988 57.6103C70.0459 59.0575 70.843 60.9808 70.843 63.0259C70.843 65.071 70.0459 66.9943 68.5988 68.4417C67.1518 69.8893 65.2285 70.6862 63.1832 70.6862ZM54.0117 51.1362C53.2867 51.1362 52.6041 51.4192 52.09 51.9333C51.5761 52.4473 51.293 53.1296 51.293 53.8549C51.293 54.5801 51.5761 55.2627 52.09 55.7766L61.2617 64.9481C61.7756 65.4622 62.4579 65.745 63.1832 65.745C63.9085 65.745 64.5908 65.462 65.1047 64.9481C65.6186 64.434 65.9019 63.7516 65.9019 63.0264C65.9019 62.3011 65.6186 61.6187 65.1047 61.1048L55.9333 51.9333C55.4194 51.4192 54.737 51.1362 54.0117 51.1362Z"
                    fill="black"
                />
            </svg>
        </div>
    );
}
